import { useCallback, useEffect, useState } from 'react';
import { bridge, isNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import type { GoodsMeasureInfo, NearBodyPartType, SizeInfo } from '../types';

const toSizeInfo = (data: GoodsMeasureInfo): SizeInfo => ({
  distanceFromBodyPart: data.distance_from_body_part,
  isPieceFullLengthDefaultValue: data.is_full_length_default_value,
  isUserHeightDefaultValue: data.is_user_height_default_value,
  nearBodyPart: data.near_body_part as NearBodyPartType | null,
  pieceFullLength: data.full_length,
  standardCategoryName: data.standard_category_name,
  userHeight: data.height,
});

export const useSizeInfoFromBridge = (params: {
  fullLength?: number | null;
}) => {
  const goodsSno = useGoodsSno();
  const fullLength = params.fullLength ?? null;

  const [sizeInfo, setSizeInfoState] = useState<SizeInfo | null>(null);

  useEffect(() => {
    bridge
      .getGoodsMeasureInfo({
        goods_sno: goodsSno,
        full_length: fullLength,
      })
      .then(result => {
        if (isNil(result)) {
          setSizeInfoState(null);
          return;
        }
        setSizeInfoState(toSizeInfo(result));
      });
  }, [goodsSno, fullLength]);

  const setSizeInfo = useCallback(
    (
      _params: { goodsSno: number; fullLength: number | null },
      newData: GoodsMeasureInfo | null,
    ) => {
      setSizeInfoState(isNil(newData) ? null : toSizeInfo(newData));
    },
    [],
  );

  return { sizeInfo, setSizeInfo };
};
